import extractPropertyFromFields from './extractPropertyFromFields';
/**
 * Extracts a specific property of the form from all fields into one object
 * @param  {Record} state - app state
 * @param  {string} formName - form name
 * @param  {string} property - property name
 * @return {Object} collection of properies from each field, and their values, for a specific form
 */

export default function extractPropertyFromState(state, formName, property) {
  return extractPropertyFromFields(state.onionForm.getIn(['fields', formName]) || [], property);
}